import React from 'react';
import useDataApi from 'utils/useDataApi';
import { Alert } from 'react-bootstrap';
import Select from 'react-select';

// Unfortunately, since we are using `simpleValue`, it becomes hard to
// have special values, so here we invent a string that
export const PER_CASE_FLAG = "<PER \b CASE>";

export default function AttributeSelector({ connectionId, cabinet, attribute, parent_key = '', input, showPerCaseOption }) {
  const [{ data, isLoading, isError }] = useDataApi(
    `/rpc/integrations/connections/${connectionId}/repository/${cabinet.repositoryId}/attribute/${attribute.id}/values?parent_key=${parent_key}`,
    {}
  );

  // TODO: remove when backend is fixed
  //  weird problem where we get junk data..., maybe should move into `useDataApi`, but should really fix backend
  if (!isError && !data) return <Alert>Unable to load values for {attribute.name}</Alert>;

  const values = data.values || [];
  const valuesOptions = values.map(val => ({
    label: <span><strong>{val.key }</strong> <em>{val.description ? ` -- ${val.description}` : ''}</em></span>,
    // label: val.description,
    value: val.key,
  }));

  if (showPerCaseOption)
    valuesOptions.unshift({
      label:
        <span>
          <strong style={{ color: 'purple', }}>Select per case</strong>
          <em> -- Needs to be specified for each case individually</em>
        </span>,
      value: PER_CASE_FLAG,
    });

  if (isError) return <Alert>Unable to load values for {attribute.name}</Alert>;

  return (
    <Select
      {...input}
      isLoading={isLoading}
      options={valuesOptions}
      simpleValue
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Integrations/NetDocuments/AttributeSelector.jsx